module.exports = __webpack_public_path__ + "img/setting_10.a32d4296.svg";